<template>
    <ais-panel>
        <template slot="header" slot-scope="{ hasRefinements }">
            <p>{{ name }} <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template slot="default">
            <ais-refinement-list :attribute="attribute"
                                 :transform-items="transformItems"
                                 show-more
                                 :class-names="{'ais-RefinementList-showMore': 'btn btn-link'}"/>
        </template>
    </ais-panel>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    transformItems: {
      type: Function,
      default: items => items,
      required: false
    }
  }
}
</script>